module.exports = __webpack_public_path__ + "static/img/5-4.97c3f6bf.png";